import { render, staticRenderFns } from "./SpecChatDrawer.vue?vue&type=template&id=862237da&scoped=true&lang=pug&"
import script from "./SpecChatDrawer.vue?vue&type=script&lang=js&"
export * from "./SpecChatDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SpecChatDrawer.vue?vue&type=style&index=0&id=862237da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862237da",
  null
  
)

export default component.exports